import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import {
  CouponCardContainer,
  CouponImage,
  Top,
  Content,
  Bottom,
  Discount,
  DiscountValue,
  DiscountOff,
  CouponCodeText,
  CouponCode,
  TopBackground,
  BottomBackground,
} from "./index.style"

import SvgCouponTop from "../../images/SVGs/CouponTop"
import SvgCouponBottom from "../../images/SVGs/CouponBottom"

const CouponCard = ({ data }) => {
  return (
    <CouponCardContainer>
      <CouponImage>
        <StaticImage src="../../images/sidebar-logo.png" alt="logo" />
      </CouponImage>
      <Top>
        <TopBackground>
          <SvgCouponTop preserveAspectRatio="none" />
        </TopBackground>
        <Content dangerouslySetInnerHTML={{ __html: data.content }} />
      </Top>
      <Bottom>
        <BottomBackground>
          <SvgCouponBottom preserveAspectRatio="none" />
        </BottomBackground>
        <Discount>
          <DiscountValue fontWeight="300">$</DiscountValue>
          <DiscountValue fontWeight="800">{data.discount}</DiscountValue>
          <DiscountOff>OFF</DiscountOff>
        </Discount>
        <CouponCodeText>{data.couponCodeText}</CouponCodeText>
        <CouponCode>{data.couponCode}</CouponCode>
      </Bottom>
    </CouponCardContainer>
  )
}

export default CouponCard
